// CustomPromptsTab.jsx - Mobile-Optimized Version
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, BookOpen, ArrowRight, ArrowLeft } from 'lucide-react';
import CustomPrompts from './CustomPrompts';

// Mobile detection hook
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  return isMobile;
};

// This component is designed to be added as a tab in the AI Suggestions dropdown
const CustomPromptsTab = ({ 
  userId, 
  onUsePrompt, 
  gameInfo = null,
  onPromptLimitReached,
  onUpgrade 
}) => {
  const isMobile = useIsMobile();
  
  // Add debugging to check the userId
  useEffect(() => {
    console.log('CustomPromptsTab - received userId:', userId);
  }, [userId]);

  // State for tracking if we're showing the full prompt manager
  const [showFullManager, setShowFullManager] = useState(false);
  
  // Handle prompt selection
  const handlePromptSelected = (promptText, promptName) => {
    if (onUsePrompt) {
      onUsePrompt(promptText);
    }
  };
  
  return (
    <div className={`${isMobile ? 'mobile-prompt-container' : ''}`}>
      {showFullManager ? (
        // Full prompt manager view - Mobile optimized
        <div className={`p-2 ${isMobile ? 'mobile-manager-view' : ''}`}>
          <div className={`flex items-center mb-4 ${isMobile ? 'mobile-header' : ''}`}>
            <button
              onClick={() => setShowFullManager(false)}
              className={`p-2 rounded-lg hover:bg-white/5 text-white/70 hover:text-white transition-colors mr-2 ${
                isMobile ? 'mobile-back-btn' : ''
              }`}
            >
              <ArrowLeft className={`${isMobile ? 'w-5 h-5' : 'w-5 h-5'}`} />
            </button>
            <h3 className={`text-lg font-medium text-white ${isMobile ? 'mobile-title' : ''}`}>
              Prompt Manager
            </h3>
          </div>
          
          <CustomPrompts 
            userId={userId}
            gameInfo={gameInfo}
            onUsePrompt={handlePromptSelected}
            onUpgrade={onUpgrade}
            showInSuggestions={false}
            isMobile={isMobile}
          />
        </div>
      ) : (
        // Compact view within suggestions dropdown - Mobile optimized
        <div className={isMobile ? 'mobile-compact-view' : ''}>
          <div className={`flex items-center justify-between mb-4 ${
            isMobile ? 'mobile-compact-header' : ''
          }`}>
            <div className="flex items-center gap-2">
              <BookOpen className={`${isMobile ? 'w-4 h-4' : 'w-5 h-5'} text-emerald-400`} />
              <h3 className={`${isMobile ? 'text-base' : 'text-lg'} font-medium text-white`}>
                My Prompts
              </h3>
            </div>
            <button
              onClick={() => setShowFullManager(true)}
              className={`flex items-center gap-1 ${
                isMobile ? 'text-xs px-2 py-1 bg-emerald-500/10 rounded-md' : 'text-sm'
              } text-emerald-400 hover:text-emerald-300 transition-colors`}
            >
              <span>Manage</span>
              <ArrowRight className={`${isMobile ? 'w-3 h-3' : 'w-4 h-4'}`} />
            </button>
          </div>
          
          <CustomPrompts 
            userId={userId}
            gameInfo={gameInfo}
            onUsePrompt={handlePromptSelected}
            onLimitReached={onPromptLimitReached}
            onUpgrade={onUpgrade}
            showInSuggestions={true}
            isMobile={isMobile}
          />
        </div>
      )}
      
      {/* Mobile-specific styles */}
      <style jsx="true">{`
        .mobile-prompt-container {
          padding: 0.5rem;
        }
        
        .mobile-manager-view {
          min-height: 60vh;
          max-height: 80vh;
          overflow-y: auto;
        }
        
        .mobile-header {
          padding-bottom: 0.75rem;
          border-bottom: 1px solid rgba(148, 163, 184, 0.1);
          margin-bottom: 1rem;
        }
        
        .mobile-back-btn {
          min-width: 40px;
          min-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .mobile-title {
          font-size: 1.125rem;
        }
        
        .mobile-compact-view {
          padding: 0.25rem;
        }
        
        .mobile-compact-header {
          flex-wrap: wrap;
          gap: 0.5rem;
        }
        
        @media (max-width: 640px) {
          .mobile-compact-header {
            align-items: flex-start;
          }
          
          .mobile-compact-header > div:first-child {
            flex: 1;
            min-width: 0;
          }
          
          .mobile-compact-header > button {
            flex-shrink: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default CustomPromptsTab;

// // CustomPromptsTab.jsx
// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import { Sparkles, BookOpen, ArrowRight } from 'lucide-react';
// import CustomPrompts from './CustomPrompts';

// // This component is designed to be added as a tab in the AI Suggestions dropdown
// const CustomPromptsTab = ({ 
//   userId, 
//   onUsePrompt, 
//   gameInfo = null,
//   onPromptLimitReached,
//   onUpgrade 
// }) => {
//   // Add debugging to check the userId
//   useEffect(() => {
//     console.log('CustomPromptsTab - received userId:', userId);
//   }, [userId]);

//   // State for tracking if we're showing the full prompt manager
//   const [showFullManager, setShowFullManager] = useState(false);
  
//   // Handle prompt selection
//   const handlePromptSelected = (promptText, promptName) => {
//     if (onUsePrompt) {
//       onUsePrompt(promptText);
//     }
//   };
  
//   return (
//     <div>
//       {showFullManager ? (
//         // Full prompt manager view
//         <div className="p-2">
//           <div className="flex items-center mb-4">
//             <button
//               onClick={() => setShowFullManager(false)}
//               className="p-2 rounded-lg hover:bg-white/5 text-white/70 hover:text-white transition-colors mr-2"
//             >
//               <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
//             </button>
//             <h3 className="text-lg font-medium text-white">Prompt Manager</h3>
//           </div>
          
//           <CustomPrompts 
//             userId={userId}
//             gameInfo={gameInfo}
//             onUsePrompt={handlePromptSelected}
//             onUpgrade={onUpgrade}
//             showInSuggestions={false}
//           />
//         </div>
//       ) : (
//         // Compact view within suggestions dropdown
//         <div>
//           <div className="flex items-center justify-between mb-4">
//             <div className="flex items-center gap-2">
//               <BookOpen className="w-5 h-5 text-emerald-400" />
//               <h3 className="text-lg font-medium text-white">My Prompts</h3>
//             </div>
//             <button
//               onClick={() => setShowFullManager(true)}
//               className="flex items-center gap-1 text-sm text-emerald-400 hover:text-emerald-300 transition-colors"
//             >
//               <span>Manage</span>
//               <ArrowRight className="w-4 h-4" />
//             </button>
//           </div>
          
//           <CustomPrompts 
//             userId={userId}
//             gameInfo={gameInfo}
//             onUsePrompt={handlePromptSelected}
//             onLimitReached={onPromptLimitReached}
//             onUpgrade={onUpgrade}
//             showInSuggestions={true}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomPromptsTab;